<template>
  <div class="main">
    <!-- Add Milestone Button -->
    <b-row>
      <b-col cols="12">
        <div class="d-flex justify-content-end">
          <b-modal id="modal-add-milestones" ok-only ok-title="Add" centered size="lg" title="Add Milestones"
            :hide-footer="true" ref="addProjectModal">
            <AddMilestone @milestoneAdded="closeAddProjectModal" />
          </b-modal>
          <b-button variant="primary" v-b-modal.modal-add-milestones>
            <feather-icon icon="PlusIcon" class="mr-50" />
            Add Milestones
          </b-button>
        </div>
      </b-col>
    </b-row>

    <div v-if="milestones.length === 0 && !loading">
      <b-row class="justify-content-center">
        <b-col md="4">
          <b-card>
            <b-card-body class="text-center">
              <h2>No Milestones available</h2>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <div class="d-block" v-else>
      <b-row class="justify-content-between">
        <b-col md="2" sm="4" class="my-1">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">Per page</label>
            <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-50" />
          </b-form-group>
        </b-col>
        <b-col md="6" class="my-1">
          <b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput"
            class="mb-0">
            <b-input-group size="sm">
              <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Type to Search" />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">
                  Clear
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12" v-if="!loading">
          <b-table striped hover responsive :per-page="perPage" :current-page="currentPage" :items="milestones"
            :fields="fields" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
            <template #cell(avatar)="data">
              <b-avatar :src="data.value" />
            </template>

            <template #cell(progress_status)="data">
              <b-badge :variant="progress_status[1][data.value]">
                {{ progress_status[0][data.value] }}
              </b-badge>
            </template>
            <template v-slot:cell(actions)="data">
              <b-dropdown variant="link" toggle-class="p-0" no-caret class="m-1">
                <template #button-content>
                  <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
                </template>
                <b-dropdown-item v-b-modal.modal-edit-milestones @click="EditTask(data.item)">
                  <feather-icon icon="EditIcon" />
                  <span class="align-middle ml-50">Edit</span>
                </b-dropdown-item>
                <b-dropdown-item @click="deleteProject(data.item.id)">
                  <feather-icon icon="TrashIcon" />
                  <span class="align-middle ml-50">Delete</span>
                </b-dropdown-item>
                <b-dropdown-item v-if="data.item.status !== 'NOTSTARTED' && data.item.status !== 'REMOVED'" :to="{
                  path: `/projectmanagement/tasks-list/${data.item.projectId}/${data.item.id}`,
                }">
                  <feather-icon icon="FileTextIcon" />
                  <span class="align-middle ml-50">Tasks</span>
                </b-dropdown-item>
                <b-dropdown-item @click="viewMilestoneDocument(data.item.id)">
                  <feather-icon icon="PaperclipIcon" />
                  <span class="align-middle ml-50">Documents</span>
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>


          <b-modal id="modal-edit-milestones" ok-only ok-title="Edit" centered size="lg" title="Edit Milestones"
            :hide-footer="true" ref="editProjectModal">
            <EditMilestones :milestone="currentTask" @MilestoneUpdated="closeEditProjectModal"/>
          </b-modal>

          <b-modal ref="modal-view-document" id="modal-view-document" ok-only ok-title="View" centered size="lg"
            title="View Documents" :hide-footer="true">
            <DocumentUpload @deleteFile="deleteFile" @downloadFile="downloadFile" @uploadFiles="uploadFiles"
              :documentDetails="documentDetails" />
          </b-modal>
        </b-col>


        <b-col cols="12">
            <b-pagination v-model="currentPage" :total-rows="milestones.length" :per-page="perPage" align="center" size="sm"
              class="my-0" />
              <b-form-group>
        Showing 
        {{ totalRows > 0 ? (perPage * (currentPage - 1) + 1) : 0 }} 
        to 
        {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }} 
        of 
        {{ totalRows > 0 ? totalRows : 0 }} 
        entries
      </b-form-group>
          </b-col>

      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BCard,
  BDropdown,
  BLink,
  BDropdownItem,
  BSpinner,
  BModal,
  VBModal,
} from "bootstrap-vue";

import AddMilestone from "./AddMilestones.vue";
import EditMilestones from "./EditMilestones.vue";
import { mapActions, mapGetters } from "vuex";
import DocumentUpload from "../component/DocumentUpload.vue";
import { customSwal, customError, customLoader } from '@/libs/customFn';

export default {
  components: {
    BCard,
    BCardBody,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BModal,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BDropdown,
    BLink,
    BDropdownItem,
    AddMilestone,
    BSpinner,
    EditMilestones,
    DocumentUpload,
    VBModal,
  },
  data() {
    return {
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentTask: {},
      currentPage: 1,
      filter: null,
      id: this.$route.params.id,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      fields: [
        { key: "name", label: "Name", sortable: true },
        { key: "description", label: "Description", sortable: true },
        { key: "totalTasks", label: "Total Tasks", sortable: true },
        { key: "startDate", label: "Start Date", sortable: true, formatter: (value) => value ? value.split('T')[0] : '' },
        { key: "endDate", label: "End Date", sortable: true, formatter: (value) => value ? value.split('T')[0] : '' },
        { key: "actions", label: "Actions" },
      ],
      statusMap: {
        NOTSTARTED: { text: "Not Started", variant: "secondary" },
        NEW: { text: "New", variant: "primary" },
        INPROGRESS: { text: "In Progress", variant: "info" },
        ONHOLD: { text: "On Hold", variant: "warning" },
        COMPLETED: { text: "Completed", variant: "success" },
        BLOCKED: { text: "Blocked", variant: "danger" },
        REMOVED: { text: "Removed", variant: "dark" },
      },

      priorityMap: {
        NOTSPECIFIED: { text: "Not Specified", variant: "secondary" },
        LOW: { text: "Low", variant: "light" },
        MEDIUM: { text: "Medium", variant: "warning" },
        HIGH: { text: "High", variant: "danger" },
      },
      documentType: "Milestones",
      documentDetails: {
        isDelete: false,
        documentList: []
      },
      currentMilestonesId: null,
    };
  },
  computed: {
    sortOptions() {
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },

    ...mapGetters("projectModule", {
      milestones: "milestones",
      loading: "loading",
    }),
    ...mapGetters('documentModule', {
      documents: 'documents',
      file: 'file',
      docloading: 'docLoader',
    }),
  },
  async mounted() {

    await this.getProjectMilestoneAction(this.id)
      .then((response) => {
        console.log("milestones", this.milestones);
        this.totalRows = this.milestones.length;
      })
      .catch((response) => {
        console.log(response);
      });

      this.$emit("updateMilestoneCount", this.milestones.length);

  },
  methods: {
    ...mapActions("projectModule", ["getProjectMilestoneAction", "addProjectTaskAction", "removeProjectMilestoneAction", "updateProjectTaskAction"]),
    
    ...mapActions("documentModule", [
      "getDocumentListAction",
      "removeDocumentAction",
      "fileSharingAction",
      "uploadDocumentAction",
      "uploadMultipleDocumentAction",
      "downloadDocumentAction"
    ]),
    
    async closeEditProjectModal() {
      this.$refs.editProjectModal.hide();
      await this.getProjectMilestoneAction(this.id)
        .then((response) => {
          this.totalRows = this.milestones.length;

        })
        .catch((response) => {
          console.log(response);
        });

      this.totalRows = this.projects.length;

    },

    async viewMilestoneDocument( milestoneIdId) {
      this.currentMilestonesId = milestoneIdId;
      await this.getDocumentListAction({id: this.id, type: this.documentType, typeId: this.currentMilestonesId});
      this.documentDetails.documentList = this.documents;
      this.documentDetails.isDelete = true;
      this.$nextTick(() => {
        this.$bvModal.show('modal-view-document');
      });
    },

    async closeAddProjectModal() {
      this.$refs.addProjectModal.hide();
      await this.getProjectMilestoneAction(this.id)
        .then((response) => {
          this.totalRows = this.milestones.length;

        })
        .catch((response) => {
          console.log(response);
        });

      this.totalRows = this.projects.length;

    },

    async closeEditProjectModal() {
      this.$refs.editProjectModal.hide();
      await this.getProjectMilestoneAction(this.id)
        .then((response) => {
          this.totalRows = this.milestones.length;

        })
        .catch((response) => {
          console.log(response);
        });

      this.totalRows = this.projects.length;
    },


    EditTask(task) {
      this.currentTask = task;
    },

    deleteProject(smtpId) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$swal({
            title: 'Deleting...',
            text: 'Please wait while the Milestone are being deleted...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              this.$swal.showLoading();
            }
          });

          this.removeProjectMilestoneAction(smtpId).then(response => {
            this.$swal.hideLoading();

            this.$swal.fire(
              'Deleted!',
              'Your Milestone have been deleted.',
              'success'
            );
            this.getProjectMilestoneAction(this.id)
              .then((response) => {
                this.totalRows = this.milestones.length;

              })
              .catch((response) => {
                console.log(response);
              });

          }).catch(error => {
            this.$swal.fire(
              'Failed to Delete!',
              error.result || 'There was a problem deleting the Milestone.',
              'error'
            );

          });
        }
      });
    },

    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    deleteRow(index) {
      // Confirm deletion
      if (confirm("Are you sure you want to delete this row?")) {
        // Remove the item at the specified index from the items array
        this.items.splice(index, 1);
        // Optionally, you can refresh any dependent data or UI here
      }
    },
    async downloadFile(id, fileName) {
      let loader = customLoader('Please wait while the document is being prepared for download');

      try {
        const response = await this.downloadDocumentAction(id);
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: response.headers['content-type'] || 'application/octet-stream',
          })
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName); // Use the provided fileName parameter directly
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Clean up DOM by removing the link element after clicking
        window.URL.revokeObjectURL(url); // Free up memory by releasing object URL

        loader.close();
      } catch (error) {
        console.error('Download failed:', error);
        loader.close();
        this.error('Failed to download the file. Please try again.'); // Updated error message for better clarity
      }
    },
    async uploadFiles(selectedFiles) {
      let loader = customLoader('Please wait while the document(s) is being added');
      const referenceId = this.id;

      if (selectedFiles.length > 1) {

        await this.uploadMultipleDocumentAction({payload: selectedFiles, referenceId: referenceId, type: this.documentType, typeId: this.currentMilestonesId})
          .then((response) => {
            customSwal('Your file(s) have been successfully uploaded.');
            loader.close();
          })
          .catch((error) => {
            customError(error);
            loader.close();
          });
      } else if (selectedFiles.length < 2) {
        await this.uploadDocumentAction({payload: selectedFiles, referenceId: referenceId, type: this.documentType, typeId: this.currentMilestonesId})
          .then((response) => {
            customSwal('Your file(s) have been successfully uploaded.');
            loader.close();
          })
          .catch((error) => {
            customError(error);
            loader.close();
          });
      }
      
      await this.getDocumentListAction({id: referenceId, type: this.documentType, typeId: this.currentMilestonesId});
      this.documentDetails.documentList = this.documents;
      
      this.$nextTick(() => {
        this.$bvModal.show('modal-view-document');
      });
    },
    async deleteFile(docId) {
      let loader = customLoader('Please wait while the document is being deleted');
      await this.removeDocumentAction(docId)
        .then((response) => {
          loader.close();
          //this.$refs['modal-view-testdocument'].hide();
          customSwal();
        })
        .catch((error) => {
          loader.close();
          //this.$refs['modal-view-testdocument'].hide();
          customError(error);
        });

      await this.getDocumentListAction({id: this.id, type: this.documentType, typeId: this.currentMilestonesId});
      this.documentDetails.documentList = this.documents;
      
      this.$nextTick(() => {
        this.$bvModal.show('modal-view-document');
      });
    },
  },
};
</script>
